import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { CustomerItem, TypeaheadService } from '../../../services/typeahead.service';

@Component({
  selector: 'tt-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.css']
})
export class DepartmentComponent implements OnInit {
    public departmentId: string;

    public deliveryCustomerButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'customersmenu', gotoParms: () => this.edit!.delivery_cust_no ?? '' }];

    public edit?: Edit;

    public selectListCompanies: BusinesscoItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService, private typeahead: TypeaheadService) {
        this.departmentId = this.stateService.getStateParams()['department_id'];
    }

    private async loadEdit() {
        if (!!this.departmentId) {
            this.edit = (await this.datatask.Post(2228, { department_id: this.departmentId }))[0];
        }
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async retrieveCustomer() {
        if (!!this.edit) {
            const response = (await this.datatask.Post(68, { cust_no: this.edit.delivery_cust_no }))[0];

            this.edit.delivery_address = response?.cust_address;
        }
    }

    public searchDeliveryCustomerNames = () => {
        return this.typeahead.searchCustomer({
            cust_name: this.edit!.delivery_cust_name,
            custtype: 'S',
            lastselect: 'SEARCH'
        });
    }

    public onDeliveryCustomerNameSelected(event?: CustomerItem) {
        if (!this.edit) return;

        this.edit.delivery_cust_no = !!event ? '' + event.item_id : '0';
        this.edit.delivery_cust_name = event?.item_name ?? '';

        this.retrieveCustomer();
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2229, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadCompanies();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    department_id: string;
    department_name: string;
    businessco_no: string;
    delivery_cust_no: string;
    delivery_cust_name: string;
    delivery_address: string;
}
